export default __webpack_public_path__ + "static/admin-identity2-bd9d369cf29894cc39e1b8cb2f558505.png";